import { CrossCircledIcon } from '@radix-ui/react-icons';
import { ComponentProps, forwardRef } from 'react';
import cn from '../../app/utils/cn';

interface ITextareaProps extends ComponentProps<'textarea'> {
  name: string;
  error?: string;
  children?: React.ReactNode;
}

export const Textarea = forwardRef<HTMLTextAreaElement, ITextareaProps>(
  ({ placeholder, name, id, error, children, className, ...props }, ref) => {
    const textareaId = id ?? name;

    return (
      <div className="relative w-full">
        <textarea
          className={cn(
            'bg-surface-input border-border-input text-text-primary peer/textarea min-h-24 w-full resize-none rounded border-2 border-solid px-2 pt-5 text-sm shadow-md outline-none placeholder-shown:pt-2 focus:border-green-600 disabled:opacity-50 dark:focus:border-green-400',
            !!error && '!border-red-500',
            className,
          )}
          ref={ref}
          name={name}
          id={textareaId}
          placeholder=" "
          {...props}
        />
        <label
          className="text-text-disabled dark:text-grey-300 pointer-events-none absolute top-1 left-2.5 text-xs transition-all duration-300 ease-in-out peer-placeholder-shown/textarea:top-3 peer-placeholder-shown/textarea:text-sm peer-disabled/textarea:opacity-50"
          htmlFor={textareaId}
        >
          {placeholder}
        </label>
        {error && (
          <div className="mt-1 flex items-center gap-1 text-xs text-red-500 dark:text-red-400">
            <CrossCircledIcon />
            <small>{error}</small>
          </div>
        )}
        {children}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';
